import CartController from '../cart/CartController';
import fragrance from "../../unique_fragrances.json";

export default class CatalogueController {

    constructor(threeController) {
        this.perfumesListElement = document.getElementById('perfumesList');
        this.cartController      = new CartController();
        this.threeController     = threeController;

        this.currentPage  = 1;
        this.itemsPerPage = 10;
        this.allProducts  = [];
        this.allPerfumes  = [];
        this.activeType   = null;

        this.init();
    }

    init() {
        this._initPaginationContainer();
        this._initSidebar();
        this.initBackToTopButton();
    }

    // ── Sidebar ───────────────────────────────────────────────────────────

    _initSidebar() {
        document.querySelectorAll('.csb-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                document.querySelectorAll('.csb-btn').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                this._closeDetailPanel();

                const gender   = btn.dataset.gender;
                const category = btn.dataset.category;
                const type     = btn.dataset.type;

                if (type === 'perfumes' && gender) {
                    this.filterPerfumesByGender(gender);
                } else if (category) {
                    this.filterCategories(category);
                }

                document.getElementById('catListEmpty').style.display   = 'none';
                document.getElementById('catListContent').style.display = 'flex';
            });
        });
    }

    // ── Pagination ────────────────────────────────────────────────────────

    _initPaginationContainer() {
        this.paginationElement = document.createElement('div');
        this.paginationElement.id = 'cataloguePagination';
        this.paginationElement.classList.add('catalogue-pagination');
        const footer = document.getElementById('clcFooter');
        if (footer) footer.appendChild(this.paginationElement);
        else this.perfumesListElement.insertAdjacentElement('afterend', this.paginationElement);
    }

    _renderPaginationBar(total) {
        this.paginationElement.innerHTML = '';
        const totalPages = Math.ceil(total / this.itemsPerPage);
        if (totalPages <= 1) return;

        const prevBtn = document.createElement('button');
        prevBtn.classList.add('pagination-status-nav');
        prevBtn.innerHTML = '&#8249; Prev';
        if (this.currentPage === 1) prevBtn.classList.add('disabled');
        prevBtn.addEventListener('click', () => this._goToPage(this.currentPage - 1));

        const center = document.createElement('div');
        center.classList.add('pagination-status-center');
        const pct = Math.round((this.currentPage / totalPages) * 100);
        center.innerHTML = `
            <div class="pagination-status-current">${this.currentPage}</div>
            <div class="pagination-status-total">of ${totalPages} pages</div>
            <div class="pagination-status-track">
                <div class="pagination-status-fill" style="width:${pct}%"></div>
            </div>`;

        const nextBtn = document.createElement('button');
        nextBtn.classList.add('pagination-status-nav');
        nextBtn.innerHTML = 'Next &#8250;';
        if (this.currentPage === totalPages) nextBtn.classList.add('disabled');
        nextBtn.addEventListener('click', () => this._goToPage(this.currentPage + 1));

        this.paginationElement.appendChild(prevBtn);
        this.paginationElement.appendChild(center);
        this.paginationElement.appendChild(nextBtn);
    }

    _goToPage(page) {
        const array = this.activeType === 'perfumes' ? this.allPerfumes : this.allProducts;
        const total = Math.ceil(array.length / this.itemsPerPage);
        if (page < 1 || page > total) return;
        this.currentPage = page;
        this._renderPage();
        this._closeDetailPanel();
        const body = document.querySelector('.clc-body');
        if (body) body.scrollTop = 0;
    }

    _renderPage() {
        const array     = this.activeType === 'perfumes' ? this.allPerfumes : this.allProducts;
        const start     = (this.currentPage - 1) * this.itemsPerPage;
        const pageItems = array.slice(start, start + this.itemsPerPage);

        this.perfumesListElement.innerHTML = '';
        const frag = document.createDocumentFragment();
        pageItems.forEach((item, i) => {
            const el = this.activeType === 'perfumes'
                ? this.createPerfumeElement(item, start + i)
                : this.createProductElement(item, start + i);
            frag.appendChild(el);
        });
        this.perfumesListElement.appendChild(frag);
        this._renderPaginationBar(array.length);
        this.perfumesListElement.style.display = 'flex';
    }

    // ── Fetching ──────────────────────────────────────────────────────────

    filterPerfumesByGender(gender) {
        let endpoint = './get_perfumes.php';
        if (gender === 'men')    endpoint += '?gender=men';
        if (gender === 'women')  endpoint += '?gender=women';
        if (gender === 'unisex') endpoint += '?gender=unisex';

        fetch(endpoint)
            .then(r => r.json())
            .then(data => this.displayPerfumes(data, gender))
            .catch(err => console.error('Error fetching perfumes:', err));
    }

    filterCategories(categoryKey) {
        const categoryMap = {
            candles:     'Aromatic Candles',
            cstBody:     'Customised Body Care Products',
            oliBody:     'Olivaloe Body Care Products',
            carrier:     'Carrier Oils',
            essential:   'Essential Oils',
            autFreshers: 'Auto Freshers',
            intFreshers: 'Interior Freshers',
            moistSkcare: 'Moisturizer Skin Creams',
            colognes:    'Colognes',
            soapanti:    'Soaps'
        };
        const categoryName = categoryMap[categoryKey];

        fetch('./get_perfumes.php')
            .then(r => r.json())
            .then(d => { this.perfumesData = d; })
            .catch(() => {});

        fetch('./get_products.php?category=' + categoryName)
            .then(r => { if (!r.ok) throw new Error('Network error'); return r.json(); })
            .then(data => {
                if (!data.length) {
                    this.perfumesListElement.innerHTML = '<p>No products found.</p>';
                    this.paginationElement.innerHTML   = '';
                    return;
                }
                const products = data.map(p => ({
                    category:       categoryName,
                    productname:    p.productname,
                    image:          p.image,
                    price:          p.price,
                    weight:         p.weight,
                    productid:      p.productid,
                    description:    p.description    || '',
                    description_gr: p.description_gr || '',
                    description_en: p.description_en || ''
                }));
                this.displayProducts(products);
            })
            .catch(err => {
                console.error('Error fetching products:', err);
                this.perfumesListElement.innerHTML = '<p>Error loading products.</p>';
            });
    }

    // ── Display ───────────────────────────────────────────────────────────

    displayProducts(products) {
        products = Array.isArray(products) ? products : [products];
        this.allProducts = products;
        this.activeType  = 'products';
        this.currentPage = 1;
        this._updateListHeader(products[0]?.category || 'Products', products.length);
        this._renderPage();
    }

    displayPerfumes(filteredData, gender) {
        filteredData = Array.isArray(filteredData) ? filteredData : [filteredData];
        gender = gender || '';
        this.allPerfumes = filteredData;
        this.activeType  = 'perfumes';
        this.currentPage = 1;
        const label = gender === 'unisex'
            ? 'Unisex Perfumes'
            : gender
                ? gender.charAt(0).toUpperCase() + gender.slice(1) + "'s Perfumes"
                : 'Perfumes';
        this._updateListHeader(label, filteredData.length);
        this._renderPage();
        document.getElementById('catListEmpty').style.display   = 'none';
        document.getElementById('catListContent').style.display = 'flex';
    }

    _updateListHeader(title, count) {
        const hdr = document.getElementById('clcHeader');
        if (!hdr) return;
        hdr.innerHTML =
            '<div class="clc-label">CATALOGUE</div>' +
            '<div class="clc-title">' + title + '</div>' +
            '<div class="clc-count">' + count + ' results</div>';
    }

    // ── List item elements ─────────────────────────────────────────────────

    createPerfumeElement(perfume, index) {
        if (!perfume) return document.createElement('div');

        const el     = document.createElement('div');
        el.className = 'perfume-item';
        el.setAttribute('data-product', perfume.product);

        const noteFields = ['notes','note','mainnotes','topnotes','aromaticnotes','middlenotes','base'];
        let notePreview  = '';
        for (const f of noteFields) {
            if (perfume[f]) { notePreview = perfume[f].split(',').slice(0,3).join(' · ').trim(); break; }
        }

        const imgSrc = perfume.image || '';
        const letter = (perfume.product || '?')[0].toUpperCase();
        const col    = this._colourForItem(perfume);

        el.innerHTML =
            '<div class="p-num">' + String(index + 1).padStart(2,'0') + '</div>' +
            '<div class="p-swatch" ' + (imgSrc
                ? 'style="background-image:url(\'' + imgSrc + '\');background-size:cover;background-position:center;"'
                : 'style="background:' + col + ';"') + '>' +
                (imgSrc ? '' : '<span class="p-swatch-letter">' + letter + '</span>') +
            '</div>' +
            '<div class="p-text">' +
                '<div class="p-name">' + (perfume.product || 'Unknown') + '</div>' +
                (notePreview ? '<div class="p-sub">' + notePreview + '</div>' : '') +
            '</div>' +
            '<div class="p-chevron">&#8250;</div>';

        el.addEventListener('click', function() {
            document.querySelectorAll('.perfume-item,.product-item').forEach(function(r) { r.classList.remove('active'); });
            el.classList.add('active');
            this.showPerfumeDetails(perfume);
        }.bind(this));

        return el;
    }

    createProductElement(product, index) {
        if (!product) return document.createElement('div');

        const el     = document.createElement('div');
        el.className = 'product-item';
        el.setAttribute('data-product', product.productname);
        el.setAttribute('data-category', product.category);

        const imgSrc = product.image || '';
        const letter = (product.productname || '?')[0].toUpperCase();
        const col    = this._colourForItem(product);

        el.innerHTML =
            '<div class="p-num">' + String(index + 1).padStart(2,'0') + '</div>' +
            '<div class="p-swatch" ' + (imgSrc
                ? 'style="background-image:url(\'' + imgSrc + '\');background-size:cover;background-position:center;"'
                : 'style="background:' + col + ';"') + '>' +
                (imgSrc ? '' : '<span class="p-swatch-letter">' + letter + '</span>') +
            '</div>' +
            '<div class="p-text">' +
                '<div class="p-name">' + product.productname + '</div>' +
                '<div class="p-sub">' + product.category + '</div>' +
            '</div>' +
            '<div class="p-chevron">&#8250;</div>';

        el.addEventListener('click', function() {
            document.querySelectorAll('.perfume-item,.product-item').forEach(function(r) { r.classList.remove('active'); });
            el.classList.add('active');
            this.showProductDetails(product);
        }.bind(this));

        return el;
    }

    // ── Detail panel helpers ───────────────────────────────────────────────

    _isMobile() { return window.innerWidth <= 768; }

    _colourForItem(item) {
        const palette = ['#7a6050','#3a6878','#2a1838','#806040','#405870','#506040','#685040','#503858','#405850','#382850','#7a5040','#486058'];
        const name = item.product || item.productname || '';
        let hash = 0;
        for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
        return palette[Math.abs(hash) % palette.length];
    }

    _buildSizePills(containerId, options, onSelect) {
        const grid = document.getElementById(containerId);
        if (!grid) return;
        grid.innerHTML = '';
        options.forEach(function(o, i) {
            const btn = document.createElement('button');
            btn.className        = 'size-pill' + (i === 0 ? ' sel' : '');
            btn.dataset.value    = o.value;
            btn.dataset.price    = o.price    || '';
            btn.dataset.wcat     = o.wcat     || '';
            btn.dataset.duration = o.duration || '';
            btn.innerHTML = '<span class="sp-label">' + o.label + '</span>' +
                (o.price ? '<span class="sp-price">' + o.price + '€</span>' : '');
            btn.addEventListener('click', function() {
                grid.querySelectorAll('.size-pill').forEach(function(b) { b.classList.remove('sel'); });
                btn.classList.add('sel');
                if (onSelect) onSelect(o);
            });
            grid.appendChild(btn);
        });
        if (options.length && onSelect) onSelect(options[0]);
    }

    _closeDetailPanel() {
        const content = document.getElementById('cdpContent');
        const empty   = document.getElementById('cdpEmpty');
        if (content) content.classList.remove('visible');
        if (empty)   empty.style.display = 'flex';
        document.querySelectorAll('.perfume-item,.product-item').forEach(function(r) { r.classList.remove('active'); });
        document.body.classList.remove('detail-panel-open');
        document.body.classList.remove('no-scroll');
        const cv = document.querySelector('canvas.webgl');
        if (cv) { cv.style.clipPath = ''; cv.style.transition = ''; }
        if (this.threeController) this.threeController.removeCurrentPerfumeBottle();
    }

    _openPanel(item, notesHtml, sizeOptions, optLabel, onAddToCart, isPerfume) {
        if (this._isMobile()) {
            this._openMobileSheet(item, notesHtml, sizeOptions, optLabel, onAddToCart, isPerfume);
        } else {
            this._openDesktopPanel(item, notesHtml, sizeOptions, optLabel, onAddToCart, isPerfume);
        }
        // Only add the Three.js bottle for perfumes, never for other products
        if (isPerfume && this.threeController) {
            this.threeController.removeCurrentPerfumeBottle();
            this.threeController.addPerfumeBottle(item.image || null, item.product || '');
        } else if (this.threeController) {
            this.threeController.removeCurrentPerfumeBottle();
        }
    }

    _openDesktopPanel(item, notesHtml, sizeOptions, optLabel, onAddToCart, isPerfume) {
        const content = document.getElementById('cdpContent');
        const empty   = document.getElementById('cdpEmpty');
        const name    = item.product || item.productname || '';
        // const brand   = item.brand   || item.category    || '';
        const col     = this._colourForItem(item);

        document.getElementById('cdpName').textContent  = name;
        // document.getElementById('cdpBrand').textContent = brand;
        document.getElementById('cdpHeroBg').style.background = 'linear-gradient(135deg,' + col + ',' + col + 'bb)';

        const tagsEl   = document.getElementById('cdpTags');
        tagsEl.innerHTML = '';
        const rawNotes = item.notes || item.note || item.mainnotes || '';
        rawNotes.split(',').slice(0,4).forEach(function(t) {
            const s = document.createElement('span');
            s.className   = 'cdp-tag';
            s.textContent = t.trim();
            tagsEl.appendChild(s);
        });

        document.getElementById('cdpNotes').innerHTML      = notesHtml;
        document.getElementById('cdpOptLabel').textContent = optLabel;
        document.getElementById('cdpConfirm').textContent  = '';
        document.getElementById('cdpAddTxt').textContent   = 'Add to Cart';

        this._buildSizePills('cdpSizeGrid', sizeOptions, function(o) {
            const el = document.getElementById('cdpPrice');
            if (el) el.textContent = (o.price || '—') + '€';
        });

        document.getElementById('cdpAddBtn').onclick = function() {
            onAddToCart(document.getElementById('cdpSizeGrid'));
            document.getElementById('cdpAddTxt').textContent = 'Added ✓';
            setTimeout(function() {
                document.getElementById('cdpAddTxt').textContent  = 'Add to Cart';
                document.getElementById('cdpConfirm').textContent = '';
            }, 2200);
        };

        document.getElementById('cdpClose').onclick = this._closeDetailPanel.bind(this);

        // Prev/next within current page
        const array     = this.activeType === 'perfumes' ? this.allPerfumes : this.allProducts;
        const start     = (this.currentPage - 1) * this.itemsPerPage;
        const pageItems = array.slice(start, start + this.itemsPerPage);
        const key       = item.product || item.productname;
        const itemIdx   = pageItems.findIndex(function(x) { return (x.product || x.productname) === key; });

        const prevBtn = document.getElementById('cdpPrev');
        const nextBtn = document.getElementById('cdpNext');
        prevBtn.style.opacity = itemIdx <= 0 ? '0.3' : '1';
        nextBtn.style.opacity = itemIdx >= pageItems.length - 1 ? '0.3' : '1';
        prevBtn.onclick = function() { if (itemIdx > 0) this._openPanelForItem(pageItems[itemIdx - 1]); }.bind(this);
        nextBtn.onclick = function() { if (itemIdx < pageItems.length - 1) this._openPanelForItem(pageItems[itemIdx + 1]); }.bind(this);

        if (empty)   empty.style.display = 'none';
        content.classList.add('visible');
        document.body.classList.add('detail-panel-open');

        // Only clip canvas for perfumes — bottle should appear in hero right side
        if (isPerfume) {
            requestAnimationFrame(function() {
                const hero = document.getElementById('cdpHero');
                const cv   = document.querySelector('canvas.webgl');
                if (hero && cv) {
                    const r = hero.getBoundingClientRect();
                    // Clip to the right 55% of the hero height area
                    // The bottle is repositioned in bottlemesh.js to x=2.0 so it
                    // renders in the right portion of the screen
                    const clipLeft = Math.round(r.left + r.width * 0.45);
                    const clipTop  = Math.round(r.top);
                    const clipBot  = Math.round(window.innerHeight - r.bottom);
                    cv.style.transition = 'clip-path 0.35s ease';
                    cv.style.clipPath   =
                        'inset(' + clipTop + 'px 0px ' + clipBot + 'px ' + clipLeft + 'px)';
                }
            });
        } else {
            // Make sure canvas is fully hidden for non-perfume products
            const cv = document.querySelector('canvas.webgl');
            if (cv) { cv.style.clipPath = 'inset(0 0 100% 0)'; cv.style.transition = ''; }
        }
    }

    _openMobileSheet(item, notesHtml, sizeOptions, optLabel, onAddToCart, isPerfume) {
        const sheet    = document.getElementById('catSheet');
        const backdrop = document.getElementById('catSheetBackdrop');
        const name     = item.product || item.productname || '';
        // const brand    = item.brand   || item.category    || '';
        const col      = this._colourForItem(item);

        document.getElementById('cssName').textContent    = name;
        // document.getElementById('cssBrand').textContent   = brand;
        document.getElementById('cssHeroBg').style.background = 'linear-gradient(135deg,' + col + ',' + col + 'bb)';
        document.getElementById('cssNotes').innerHTML     = notesHtml;
        document.getElementById('cssOptLabel').textContent = optLabel;
        document.getElementById('cssConfirm').textContent  = '';
        document.getElementById('cssAddTxt').textContent   = 'Add to Cart';

        this._buildSizePills('cssSizeGrid', sizeOptions, null);

        // CSS SVG animated bottle for mobile (canvas is hidden on mobile)
        var cssHero = document.getElementById('cssHero');
        var existingBottle = cssHero ? cssHero.querySelector('.css-svg-bottle') : null;
        if (existingBottle) existingBottle.remove();
        if (isPerfume && cssHero) {
            var bottleCol = col;
            var bottleLtr = (name || '?')[0].toUpperCase();
            var bottleDiv = document.createElement('div');
            bottleDiv.className = 'css-svg-bottle';
            bottleDiv.style.cssText = 'position:absolute;right:16px;top:50%;transform:translateY(-50%);z-index:2;opacity:0.85;';
            bottleDiv.innerHTML = '<svg style="animation:cssBSpin 8s linear infinite;" width="52" height="90" viewBox="0 0 52 96" fill="none">' +
                '<rect x="18" y="0" width="16" height="9" rx="2" fill="rgba(255,255,255,0.35)"/>' +
                '<rect x="14" y="9" width="24" height="6" rx="1.5" fill="rgba(255,255,255,0.22)"/>' +
                '<rect x="7" y="15" width="38" height="68" rx="8" fill="rgba(255,255,255,0.22)" stroke="rgba(255,255,255,0.4)" stroke-width="1"/>' +
                '<rect x="11" y="19" width="10" height="58" rx="4" fill="rgba(255,255,255,0.12)"/>' +
                '<text x="26" y="56" text-anchor="middle" font-size="18" fill="rgba(255,255,255,0.5)" font-family="Georgia,serif" font-style="italic">' + bottleLtr + '</text>' +
                '</svg>';
            cssHero.appendChild(bottleDiv);
        }

        document.getElementById('cssAddBtn').onclick = function() {
            onAddToCart(document.getElementById('cssSizeGrid'));
            document.getElementById('cssAddTxt').textContent  = 'Added ✓';
            setTimeout(function() {
                document.getElementById('cssAddTxt').textContent  = 'Add to Cart';
                document.getElementById('cssConfirm').textContent = '';
            }, 2200);
        };

        const self  = this;
        const close = function() {
            backdrop.classList.remove('open');
            sheet.classList.remove('open');
            document.body.classList.remove('no-scroll');
            document.body.classList.remove('detail-panel-open');
            // Remove CSS SVG bottle from hero
            var hero = document.getElementById('cssHero');
            if (hero) { var b = hero.querySelector('.css-svg-bottle'); if (b) b.remove(); }
            if (self.threeController) self.threeController.removeCurrentPerfumeBottle();
        };
        document.getElementById('cssClose').onclick = close;
        backdrop.onclick = close;

        backdrop.classList.add('open');
        sheet.classList.add('open');
        document.body.classList.add('no-scroll');
        document.body.classList.add('detail-panel-open');
    }

    _openPanelForItem(item) {
        document.querySelectorAll('.perfume-item,.product-item').forEach(function(r) { r.classList.remove('active'); });
        const key = item.product || item.productname;
        const el  = document.querySelector('[data-product="' + key + '"]');
        if (el) el.classList.add('active');
        if (this.activeType === 'perfumes') this.showPerfumeDetails(item);
        else this.showProductDetails(item);
    }

    // ── Show Perfume Details ───────────────────────────────────────────────

    showPerfumeDetails(perfume) {
        const noteFields = [
            ['Year', perfume.year], ['Notes', perfume.notes], ['Note', perfume.note],
            ['Middle Notes', perfume.middlenotes], ['Main Notes', perfume.mainnotes],
            ['Top Notes', perfume.topnotes], ['Aromatic Notes', perfume.aromaticnotes],
            ['Base', perfume.base], ['Contains', perfume.contains],
        ];
        const notesHtml = noteFields.filter(function(x) { return x[1]; })
            .map(function(x) { return '<strong>' + x[0] + ':</strong> ' + x[1]; }).join('<br>');

        const self = this;
        fetch('./get_prices.php?category=Perfumes')
            .then(function(r) { return r.json(); })
            .then(function(pricesData) {
                const options = pricesData.map(function(p) {
                    return {
                        label: p.weight <= 0.014 + Number.EPSILON ? p.weightcategory + ' (Pure)' : p.weightcategory,
                        value: p.weight,
                        price: p.price,
                        wcat:  p.weightcategory
                    };
                });

                const onAddToCart = function(grid) {
                    const sel = grid.querySelector('.size-pill.sel');
                    if (!sel) { alert('Please choose a size.'); return; }
                    self.cartController.addToCart(perfume, sel.dataset.price, sel.dataset.value, null, null, null, perfume.brand, sel.dataset.wcat);
                };

                self._openPanel(perfume, notesHtml, options, 'Choose Size', onAddToCart, true);
            })
            .catch(function(err) { console.error('Error loading perfume prices:', err); });
    }

    // ── Show Product Details ───────────────────────────────────────────────

    showProductDetails(product) {
        if (this.threeController && this.threeController.removeCurrentPerfumeBottle) {
            this.threeController.removeCurrentPerfumeBottle();
        }

        const descText  = this.getProductDescription(product);
        const notesHtml = descText ? '<p>' + descText + '</p>' : '<p>Discover our ' + product.category + '.</p>';
        const self      = this;

        fetch('./get_perfumes.php')
            .then(function(r) { return r.json(); })
            .then(function(perfumesData) {
                self.perfumesData = perfumesData;
                return fetch('./get_prices.php?category=' + product.category)
                    .then(function(r) { return r.json(); })
                    .then(function(pricesData) {
                        var options  = [];
                        var optLabel = 'Options';

                        switch (product.category) {
                            case 'Aromatic Candles':
                                optLabel = 'Choose Duration';
                                options  = pricesData.map(function(p) { return { label: p.duration + 'h', value: p.weight, price: p.price, duration: p.duration }; });
                                break;
                            case 'Colognes':
                                optLabel = 'Choose Size';
                                options  = pricesData.map(function(p) { return { label: p.weight + 'kg', value: p.weight, price: p.price }; });
                                break;
                            case 'Customised Body Care Products': {
                                var isToothpaste = product.productname.toLowerCase().includes('toothpaste') || product.productname.toLowerCase().includes('οδοντοκρεμα');
                                if (!isToothpaste) {
                                    optLabel = 'Choose Scent';
                                    options  = perfumesData.map(function(p) { return { label: p.product, value: p.product, price: product.price }; });
                                } else {
                                    optLabel = 'Price';
                                    options  = [{ label: product.weight + 'kg', value: product.weight, price: product.price }];
                                }
                                break;
                            }
                            case 'Auto Freshers':
                            case 'Interior Freshers':
                                if (product.productname.includes('with Perfume')) {
                                    optLabel = 'Choose Scent';
                                    options  = perfumesData.map(function(p) { return { label: p.product, value: p.product, price: product.price }; });
                                } else if (product.productname.includes('with Fragrance')) {
                                    optLabel = 'Choose Fragrance';
                                    options  = fragrance.map(function(p) { return { label: p.Name, value: p.Name, price: product.price }; });
                                } else {
                                    optLabel = 'Price';
                                    options  = [{ label: product.weight + 'kg', value: product.weight, price: product.price }];
                                }
                                break;
                            default:
                                optLabel = 'Price';
                                options  = [{ label: product.weight + 'kg', value: product.weight, price: product.price }];
                        }

                        var onAddToCart = function(grid) {
                            var sel = grid.querySelector('.size-pill.sel');
                            var w   = product.weight, p = product.price, sc = null, fr = null, dur = null;
                            if (sel) {
                                w   = sel.dataset.value;
                                p   = sel.dataset.price || product.price;
                                dur = sel.dataset.duration || null;
                                if (optLabel === 'Choose Scent')     sc  = sel.dataset.value;
                                if (optLabel === 'Choose Fragrance') fr  = sel.dataset.value;
                            }
                            self.cartController.addToCart(product, p, w, sc, fr, dur, null, null);
                        };

                        self._openPanel(product, notesHtml, options, optLabel, onAddToCart, false);
                    });
            })
            .catch(function(err) { console.error('Error loading product data:', err); });
    }

    // ── Misc ──────────────────────────────────────────────────────────────

    getCurrentLanguage() {
        const match = document.cookie.match(/(?:^|;\s*)language=([^;]*)/);
        const lang  = match ? decodeURIComponent(match[1]) : 'eng';
        return (lang === 'gr' || lang === 'eng') ? lang : 'eng';
    }

    getProductDescription(product) {
        const lang = this.getCurrentLanguage();
        return lang === 'gr'
            ? (product.description_gr || product.description_en || product.description || '')
            : (product.description_en || product.description_gr || product.description || '');
    }

    highlightSelectedPerfume(perfume) {
        const el = document.querySelector('[data-product="' + perfume + '"]');
        if (!el) return;
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.classList.add('nudge-animation');
        setTimeout(function() { el.classList.remove('nudge-animation'); }, 1000);
    }

    scrollToProducts() {
        if (window.innerWidth > 768 || !this.perfumesListElement) return;
        const rect = this.perfumesListElement.getBoundingClientRect();
        window.scrollTo({ top: rect.top + window.pageYOffset - 80, behavior: 'smooth' });
    }

    convertKgToMl(kg) { return kg * 1000; }

    initBackToTopButton() {
        const btn  = document.getElementById('backToTopBtn');
        const list = this.perfumesListElement;
        if (!btn || !list) return;
        const toggle = function() { btn.style.display = list.scrollTop > 20 ? 'block' : 'none'; };
        list.addEventListener('scroll', toggle);
        btn.addEventListener('click', function() { list.scrollTo({ top: 0, behavior: 'smooth' }); });
    }
}